import { render, staticRenderFns } from "./ModulesWeb.vue?vue&type=template&id=98e2aa62"
import script from "./ModulesWeb.vue?vue&type=script&lang=js"
export * from "./ModulesWeb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports